import type { CalendarEvent } from 'owa-calendar-types';
import { subMinutes, isWithinRange } from 'owa-datetime';
import { isCalendarEventLocalLie } from 'owa-calendar-event-local-lie';
import { hasReadRights } from 'owa-calendar-event-capabilities';
import { observableNow } from 'owa-observable-datetime';

/**
 * Determines whether given event is online and about to happen / happening
 *
 * @param event - event to consider
 * @returns  a flag indicating whether the given event is online and about to happen / happening
 */
export function isOnlineEventHappeningNow(event: CalendarEvent): boolean {
    // Ignore the event if it is not an online meeting or if it doesn't have join url
    if (!event.IsOnlineMeeting || event.OnlineMeetingJoinUrl === null) {
        return false;
    }

    const now = observableNow();
    const isEventBeforeNow = isWithinRange(subMinutes(now, 1), event.Start, event.End);
    const isEventNow = isWithinRange(now, event.Start, event.End);

    return (
        (isEventBeforeNow || isEventNow) &&
        !event.IsCancelled &&
        !event.IsDraft &&
        event.ResponseType !== 'Decline' &&
        !isCalendarEventLocalLie(event) &&
        hasReadRights(event)
    );
}
